import React from 'react';
import { IconContext } from "react-icons";
import { FiCamera } from "react-icons/fi";

import { Trans } from 'react-i18next';

const PhotosCard = ( props ) => {

  return (
    <div className="card photos" onClick={ ( ) => { document.getElementById( 'observationsSection' ).scrollIntoView({ behavior: 'smooth' }) } }>
      <div className="data">
        <div className="amount"> { props.amount } </div>
        <div className="tag"> <Trans>Photos</Trans> </div>
      </div>
      <div className="icon">
        <div className="container">
          <IconContext.Provider value={{ size: "20px" }}>
            <div>
              <FiCamera />
            </div>
          </IconContext.Provider>
        </div>
      </div>
    </div>
  )
}

export default PhotosCard
